import React from "react";
import PropTypes from "prop-types";
import { DataTable } from "MODULES/shared/components";
import {
  RECEIVING_CHECKLIST_QUESTIONS,
  MISTAKE_SHIPMENT,
  RECEIVED_VIRTUALLY,
  RECEIVING_TYPE
} from "MODULES/Receiving/constants";
import EditButton from "MODULES/Receiving/Detail/EditQuestionsChecklist/EditButton";
import AuditedNoteTooltip from "MODULES/shared/components/NoteTooltip/AuditedNoteTooltip";

function NoLabel() {
  return (
    <span className="label label-danger">
      <i className="fa fa-warning" />
      <span className="with-padding">No</span>
    </span>
  );
}
function YesLabel() {
  return (
    <span className="label label-success">
      <i className="fa fa-check" />
      <span className="with-padding">Yes</span>
    </span>
  );
}

export default function QuestionsChecklist({ receivingRecord }) {
  const showList = Object.keys(RECEIVING_CHECKLIST_QUESTIONS).some(
    key => typeof receivingRecord.get(key) === "boolean"
  );

  const renderRow = (attr, questionText, record) => (
    <tr>
      <td>{record.get(attr) ? <YesLabel /> : <NoLabel />}</td>
      <td>{questionText}</td>
      <td>
        <AuditedNoteTooltip obj={record.toJS()} field={attr} placement="left" />
      </td>
    </tr>
  );

  if (
    !showList ||
    (receivingRecord.get(RECEIVED_VIRTUALLY) &&
      receivingRecord.get("reference_record_line_item_type") !==
        "InventoryTransferOrder") ||
    receivingRecord.get(RECEIVING_TYPE) === MISTAKE_SHIPMENT
  )
    return null;
  return (
    <div>
      <h2 style={{ marginTop: 10 }}>
        Receiving Inspection Checklist
        <EditButton />
      </h2>
      <DataTable.Mini>
        <DataTable.Head>
          <th>Response</th>
          <th>Question</th>
          <th />
        </DataTable.Head>
        <DataTable.Body>
          {Object.keys(RECEIVING_CHECKLIST_QUESTIONS).map(key =>
            renderRow(key, RECEIVING_CHECKLIST_QUESTIONS[key], receivingRecord)
          )}
        </DataTable.Body>
      </DataTable.Mini>
    </div>
  );
}

QuestionsChecklist.propTypes = {
  receivingRecord: PropTypes.instanceOf(Object).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/Receiving/Detail/QuestionsChecklist.jsx